// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay__overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 4;
}
.overlay__overlay .overlay__background {
  background-color: rgba(0, 0, 0, 0.85);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 0;
}
.overlay__overlay .overlay__columnLeft,
.overlay__overlay .overlay__columnRight {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  width: 10%;
  font-size: 2em;
  cursor: pointer;
}
.overlay__overlay .overlay__columnRight {
  right: 0;
  z-index: 2;
}
.overlay__overlay .overlay__columnLeft {
  left: 0;
  z-index: 2;
}
.overlay__overlay .overlay__columnLeft:hover,
.overlay__overlay .overlay__columnRight:hover {
  background-color: rgba(255, 255, 255, 0.15);
}
.overlay__overlay .overlay__closeButton {
  position: fixed;
  right: 0;
  top: 0;
  width: 10%;
  height: 2.5em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 2em;
  cursor: pointer;
  z-index: 3;
  visibility: visible;
  opacity: 1;
}
.overlay__overlay .overlay__closeButton:hover {
  background-color: rgba(107, 12, 5, 0.5);
}
.overlay__overlay .overlay__spinner {
  color: #FFF;
  z-index: 10;
  font-size: 10vh;
}
.overlay__overlay .overlay__pictureContainer {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  top: 0px;
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
}
.overlay__overlay .overlay__pictureContainer .overlay__infoAction {
  width: 100%;
  font-weight: 200;
  letter-spacing: 2px;
  font-size: 0.6em;
  padding-bottom: 0.3em;
}
.overlay__overlay .overlay__pictureContainer .overlay__infoAction .overlay__info {
  width: auto;
  padding-left: 0.3em;
  display: inline-block;
  text-align: left;
  z-index: 10;
}
.overlay__overlay .overlay__pictureContainer .overlay__infoAction .overlay__info .overlay__id {
  opacity: 0.33;
}
.overlay__overlay .overlay__pictureContainer .overlay__pictureHover {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  cursor: pointer;
  z-index: 1;
}
.overlay__overlay .overlay__pictureContainer .overlay__pictureHover .overlay__icon {
  position: absolute;
  font-size: 1em;
  opacity: 0;
  visibility: hidden;
  transition: font-size 500ms, visibility 0s linear 0s, opacity 500ms;
}
.overlay__overlay .overlay__pictureContainer .overlay__picture {
  max-width: 75vw;
  max-height: 80vh;
  display: block;
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  border: 1px solid rgba(255, 255, 255, 0.15);
}
.overlay__overlay .overlay__pictureContainer .overlay__pictureLoading {
  width: min(80vh, 50vw);
  height: min(80vh, 50vw);
  border: 1px solid rgba(255, 255, 255, 0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Overlay/Overlay.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AACF;AAVA;EAYQ,qCAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;AACR;AAlBA;;EAsBQ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,MAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;AAAR;AA9BA;EAkCQ,QAAA;EACA,UAAA;AADR;AAlCA;EAuCQ,OAAA;EACA,UAAA;AAFR;AAtCA;;EA6CQ,2CAAA;AAHR;AA1CA;EAiDQ,eAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,UAAA;EACA,mBAAA;EACA,UAAA;AAJR;AA1DA;EAkEQ,uCAAA;AALR;AA7DA;EAsEQ,WAAA;EACA,WAAA;EACA,eAAA;AANR;AAlEA;EA4EQ,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,iBAAA;EACA,sBAAA;EACA,wBAAA;EACA,yBAAA;EACA,oBAAA;AAPR;AA/EA;EAyFY,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AAPZ;AAtFA;EA+FgB,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;AANhB;AA7FA;EAqGoB,aAAA;AALpB;AAhGA;EA2GY,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAAA;EACA,wBAAA;EACA,yBAAA;EACA,oBAAA;EACA,eAAA;EACA,UAAA;AARZ;AAhHA;EA2HgB,kBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,mEAAA;AARhB;AAvHA;EAqIY,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,wBAAA;EACA,yBAAA;EACA,oBAAA;EACA,2CAAA;AAXZ;AAlIA;EAiJY,sBAAA;EACA,uBAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAZZ","sourcesContent":[".overlay__overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 4;\n\n    .overlay__background {\n        background-color: rgba(0, 0, 0, .85);\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        z-index: 0;\n    }\n\n    .overlay__columnLeft,\n    .overlay__columnRight {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        position: fixed;\n        top: 0;\n        width: 10%;\n        font-size: 2em;\n        cursor: pointer;\n    }\n\n    .overlay__columnRight {\n        right: 0;\n        z-index: 2;\n    }\n\n    .overlay__columnLeft {\n        left: 0;\n        z-index: 2;\n    }\n\n    .overlay__columnLeft:hover,\n    .overlay__columnRight:hover {\n        background-color: rgba(255, 255, 255, 0.15);\n    }\n\n    .overlay__closeButton {\n        position: fixed;\n        right: 0;\n        top: 0;\n        width: 10%;\n        height: 2.5em;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        font-size: 2em;\n        cursor: pointer;\n        z-index: 3;\n        visibility: visible;\n        opacity: 1;\n    }\n\n    .overlay__closeButton:hover {\n        background-color: rgba(107, 12, 5, 0.5);\n    }\n\n    .overlay__spinner {\n        color: #FFF;\n        z-index: 10;  \n        font-size: 10vh;\n    }\n\n    .overlay__pictureContainer {\n        position: relative;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        top: 0px;\n        user-select: none;\n        -moz-user-select: none;\n        -khtml-user-select: none;\n        -webkit-user-select: none;\n        -o-user-select: none;\n\n        .overlay__infoAction {\n            width: 100%;\n            font-weight: 200;\n            letter-spacing: 2px;\n            font-size: .6em;\n            padding-bottom: .3em;\n            .overlay__info {\n                width: auto;\n                padding-left: .3em;\n                display: inline-block;\n                text-align: left;\n                z-index: 10;\n                .overlay__id {\n                    opacity: .33;\n                }\n            }\n        }\n\n        .overlay__pictureHover {\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            user-select: none;\n            -moz-user-select: none;\n            -khtml-user-select: none;\n            -webkit-user-select: none;\n            -o-user-select: none;\n            cursor: pointer;\n            z-index: 1;\n\n            .overlay__icon{\n                position: absolute;\n                font-size: 1em;\n                opacity: 0;\n                visibility: hidden;\n                transition: font-size 500ms, visibility 0s linear 0s, opacity 500ms;\n            }\n\n        }\n\n        .overlay__picture {\n            max-width: 75vw;\n            max-height: 80vh;\n            display: block;\n            user-select: none;\n            -moz-user-select: none;\n            -khtml-user-select: none;\n            -webkit-user-select: none;\n            -o-user-select: none;\n            border: 1px solid rgba(255, 255, 255, 0.15);\n        }\n\n        .overlay__pictureLoading {\n            width: min(80vh, 50vw);\n            height: min(80vh, 50vw);\n            border: 1px solid rgba(255, 255, 255, 0.15);\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n        }\n\n    }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
